export const getPopUpWrapperStyles = (isSmall: boolean) => ({
  padding: 2,
  boxSizing: "border-box",
  width: isSmall ? "auto" : 310,
});
